"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const MatchDetailsRow_1 = __importDefault(require("@Components/MatchComponents/MatchDetailsTable/MatchDetailsRow"));
const MatchDetailsTable = (props) => {
    var _a;
    return (react_1.default.createElement("table", { className: "result-details-table" },
        react_1.default.createElement("tbody", null,
            react_1.default.createElement("tr", null,
                react_1.default.createElement("th", null, "DSP"),
                react_1.default.createElement("th", null, "Product Title"),
                react_1.default.createElement("th", null, "Product Artist"),
                react_1.default.createElement("th", null, "Product Label"),
                react_1.default.createElement("th", { className: 'with-tooltip' },
                    react_1.default.createElement("p", null,
                        "Audio",
                        react_1.default.createElement(CustomToolTip_1.default, { type: '?', info: 'Not all audio links may be available. Older audio may ' +
                                'have been removed from digital streaming platforms.' }))),
                react_1.default.createElement("th", null, "Details")), (_a = props.recordings) === null || _a === void 0 ? void 0 :
            _a.map((recording) => (react_1.default.createElement(MatchDetailsRow_1.default, { recording: recording, key: `${recording.dspMNumber}-${recording.senderResourceId}` }))))));
};
exports.default = MatchDetailsTable;
